var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sync-status-badge",class:_vm.cssClass,style:(_vm.color ? { background: _vm.color } : undefined)},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }